(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Hash scroll functionality
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Mobile filter drawer.
  //
  // Applying a filter re-renders this entire section through the Section Rendering
  // API (assets/facets.js -> sectionRenderer.renderSection). That caused three
  // compounding problems, which together produced the stuck black screen:
  //
  //   1. The toggle and close buttons live INSIDE the re-rendered section, so
  //      listeners bound once at DOMContentLoaded died with the old elements —
  //      both buttons stopped responding after the first filter was applied.
  //   2. The sidebar is inside the section (so it lost .active on re-render) but
  //      the overlay was appended to <body> (so it kept .active). The dimmer
  //      survived while the drawer behind it disappeared.
  //   3. z-index 99/100 sat above the theme's whole layer scale (max 20, menu
  //      drawer 18), so that orphaned dimmer also covered the hamburger menu.
  //
  // Fixed by keeping open/closed state in a class on <body>, which no section
  // re-render touches, and by delegating every click from document.
  document.addEventListener('DOMContentLoaded', () => {
    const OPEN = 'filters-drawer-open';

    // One overlay for the life of the page; guard against duplicates.
    let overlay = document.querySelector('.filters-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'filters-overlay';
      document.body.appendChild(overlay);
    }

    const openDrawer = () => document.body.classList.add(OPEN);
    const closeDrawer = () => document.body.classList.remove(OPEN);

    // Delegated, so it keeps working after the section re-renders.
    document.addEventListener('click', (event) => {
      if (event.target.closest('.filters-toggle-mobile')) {
        event.preventDefault();
        openDrawer();
        return;
      }
      if (event.target.closest('.filters-sidebar__close') || event.target.closest('.filters-overlay')) {
        event.preventDefault();
        closeDrawer();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDrawer();
    });

    // Never leave the drawer open on desktop, where the sidebar is static.
    window.addEventListener('resize', () => {
      if (window.innerWidth > 749) closeDrawer();
    }, { passive: true });

    // ── Sort select ──────────────────────────────────────────────────────────
    const sortSelect = document.getElementById('CollectionSortBy');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        const params = new URLSearchParams(window.location.search);
        params.set('sort_by', sortSelect.value);
        // Reset to page 1 when sort changes
        params.delete('page');
        window.location.search = params.toString();
      });
    }

    // ── Category (tag) filter checkboxes ────────────────────────────────────
    const categoryCheckboxes = document.querySelectorAll('.category-filter-checkbox');
    categoryCheckboxes.forEach(cb => {
      cb.addEventListener('change', () => {
        const filterType = cb.dataset.filterType || 'tag';
        const params = new URLSearchParams(window.location.search);
        params.delete('page');

        // Build base collection URL (strip any existing tag path segment)
        const pathParts = window.location.pathname.split('/').filter(Boolean);
        const collIdx = pathParts.indexOf('collections');
        const baseSegments = collIdx !== -1 ? pathParts.slice(0, collIdx + 2) : pathParts;
        const basePath = '/' + baseSegments.join('/');

        if (filterType === 'type') {
          // Product type filter: uses ?filter.p.product_type=Value
          params.delete('filter.p.product_type');
          const checked = Array.from(document.querySelectorAll('.category-filter-checkbox:checked'));
          checked.forEach(el => params.append('filter.p.product_type', el.value));
          window.location.href = basePath + (params.toString() ? '?' + params.toString() : '');
        } else {
          // Tag filter: uses /collections/handle/tag-slug
          const checked = Array.from(document.querySelectorAll('.category-filter-checkbox:checked'));
          if (checked.length > 0) {
            window.location.href = basePath + '/' + checked[0].value + (params.toString() ? '?' + params.toString() : '');
          } else {
            window.location.href = basePath + (params.toString() ? '?' + params.toString() : '');
          }
        }
      });
    });

    // Active-tag accordion toggle
    document.querySelectorAll('.filter-group__toggle').forEach(toggle => {
      toggle.addEventListener('click', () => {
        const group = toggle.closest('.filter-group');
        group.classList.toggle('is-collapsed');
        toggle.setAttribute('aria-expanded', !group.classList.contains('is-collapsed'));
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
